import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Services from "common/Services/Services";
import Layout from "components/Layout";
import SEO from "components/Seo";
import * as styles from "styles/ofertaDetail.module.scss";

const services = [
  { key: "implanty" },
  { key: "ortognatyka" },
  { key: "stomatologia-zachowawcza" },
  { key: "radiologia" },
];

const ChirurgiaStomatologicznaPage = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <SEO
        title={formatMessage({
          id: "oferta.chirurgia-stomatologiczna.seo.title",
        })}
        description={formatMessage({
          id: "oferta.chirurgia-stomatologiczna.seo.description",
        })}
      />
      <main>
        <article className={styles.article}>
          <section>
            <h1>{formatMessage({ id: "oferta.chirurgia-stomatologiczna.h1" })}</h1>
            <div className={styles.text}>
              <FormattedMessage id="oferta.chirurgia-stomatologiczna.osemki" tagName="h3" />
              <FormattedMessage id="oferta.chirurgia-stomatologiczna.osemki.p.1" tagName="p" />
            </div>
            <div className={styles.text}>
              <FormattedMessage id="oferta.chirurgia-stomatologiczna.resekcja" tagName="h3" />
              <FormattedMessage id="oferta.chirurgia-stomatologiczna.resekcja.p.1" tagName="p" />
            </div>
            <div className={styles.text}>
              <FormattedMessage
                id="oferta.chirurgia-stomatologiczna.periodontologia"
                tagName="h3"
              />
              <FormattedMessage
                id="oferta.chirurgia-stomatologiczna.periodontologia.p.1"
                tagName="p"
              />
            </div>
            <div className={styles.text}>
              <FormattedMessage id="oferta.chirurgia-stomatologiczna.torbiele" tagName="h3" />
              <FormattedMessage id="oferta.chirurgia-stomatologiczna.torbiele.p.1" tagName="p" />
            </div>
          </section>
          <section>
            <Services services={services} />
          </section>
        </article>
      </main>
    </>
  );
};

export default ChirurgiaStomatologicznaPage;
